export const ChangeLogType = {
    unknown: 0,
    pricing: 1
};

export default ChangeLogType;
